// Plain-JSON fetch helper for non-Inertia endpoints (request execution,
// effective-settings preview, mock log polling).
export async function apiFetch<T>(url: string, options: RequestInit = {}): Promise<T> {
  const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

  const response = await fetch(url, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
      ...options.headers,
    },
    credentials: "same-origin",
  })

  if (!response.ok) {
    const text = await response.text().catch(() => "")
    throw new ApiError(response.status, text)
  }
  return (await response.json()) as T
}

export class ApiError extends Error {
  status: number
  body: string

  constructor(status: number, body: string) {
    super(`Request failed with status ${status}`)
    this.status = status
    this.body = body
  }
}
